import { useQuery } from '@tanstack/react-query';
import { get } from '@truefit/http-utils';

import { isSignedIn, useAuth } from '@/features/scaffolding/components/AuthContext';

export interface McpConsentOrg {
  id: number;
  name: string;
  logoPath: string | null;
}

export interface McpConsentRequest {
  client: { name: string };
  /** The orgs where the user holds write:mcp; empty when there are none. */
  orgs: McpConsentOrg[];
}

/** The pending authorization request an MCP client sent the user here with. */
export const useMcpConsentRequestQuery = (requestId: string | null) => {
  const { sessionState } = useAuth();

  return useQuery({
    queryKey: ['McpConsentRequest', requestId],
    queryFn: async () => {
      const { data } = await get<McpConsentRequest>(`/v1.0/oauth/requests/${requestId}`);
      return data;
    },
    // Signed in is enough: this page runs without a cloud player, so READY never comes.
    enabled: !!requestId && isSignedIn(sessionState),
    // A 404 means expired or already used; asking again won't change that.
    retry: false,
  });
};

export default useMcpConsentRequestQuery;
